import { throttle } from "@app/utils";
import { useEffect, useState } from "react";
import { Dimensions } from "react-native";

export default function useWindowDimensionsThrottled(throttleMs = 200) {
  const { width, height } = Dimensions.get("window");
  const [windowSize, setWindowSize] = useState({ width, height });

  useEffect(() => {
    const handler = throttle(({ window }: any) => {
      setWindowSize({ width: window.width, height: window.height });
    }, throttleMs);

    const subscription = Dimensions.addEventListener("change", handler);

    return () => subscription?.remove();
  }, [throttleMs]);

  return windowSize;
}